/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface SupportTicket {
  _id: string;
  title: string;
  description: string;
  images?: string[];
  priority: "low" | "medium" | "high";
  status?: string;
  createdAt?: string;
  updatedAt?: string;
}

export type SupportTicketPayload = {
  title: string;
  description: string;
  images?: string[];
  priority: "low" | "medium" | "high";
};

export type SupportTicketResponse = {
  success: boolean;
  message: string;
  data: SupportTicket;
};

const addSupportTicket = async (
  payload: SupportTicketPayload
): Promise<SupportTicketResponse> => {
  const { data } = await customAxios.post<SupportTicketResponse>(
    "/support-tickets",
    payload
  );
  return data;
};

export const useAddSupportTicket = () => {
  const queryClient = useQueryClient();

  return useMutation<SupportTicketResponse, AxiosError, SupportTicketPayload>({
    mutationFn: addSupportTicket,

    onSuccess: async (data) => {
      // showNotification({
      //   title: "Success",
      //   message: data.message,
      //   color: "green",
      // });

      await queryClient.invalidateQueries(["support-tickets"]);
    },

    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to create support ticket",
        color: "red",
      }),
  });
};
